import styled, { css } from 'styled-components';
import { TGroupLayout } from './radio.types';

export const RadioSC = styled.span<{ disabled?: boolean; readOnly?: boolean; error?: boolean }>`
  &,
  label {
    display: inline-flex;
    position: relative;
    transition: all 0.2s;
    align-items: center;
    margin: 0;
  }

  .radio-group-vertical & {
    margin: 12px 0;
    margin-left: 16px;
  }

  .radio-group-horizontal & {
    margin-right: 16px;
    margin-left: 16px;
    padding: 12px 0;

    &:last-child {
      margin-right: 0px;
    }
  }

  ${({ disabled, readOnly }) =>
    disabled || readOnly
      ? css`
          cursor: not-allowed;
          opacity: 0.5;
        `
      : css`
          & * {
            cursor: pointer;
          }
          opacity: 1;
        `};

  .radio-control {
    position: relative;
    transition: all 0.2s;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 32px;

    .radio-handle {
      width: 20px;
      height: 20px;
      transition: all 0.2s;

      display: flex;
      align-items: center;
      justify-content: center;

      border-radius: 20px;
      z-index: 1;

      .ui-radio-mark {
        opacity: 0;
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background-color: ${({ theme }) => theme.color.surface.baseline};
        transition: all 0.2s;
      }
    }

    &:before {
      z-index: 0;
      content: '';
      position: absolute;
      inset: -6px;
      border-radius: 32px;
      transition: all 0.2s;
    }

    &:hover {
      &:before {
        background-color: ${({ theme }) => theme.color.state.ripple};
      }
    }
  }

  input {
    cursor: inherit;
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    margin: 0;
    padding: 0;
    transition: all 0.2s;

    &:checked + .radio-handle {
      .ui-radio-mark {
        opacity: 1;
      }
    }
  }

  ${({ theme, error }) => {
    const backgroundColor = error ? theme.color.surface.error : theme.color.surface.variant;
    const borderColor = error ? theme.color.border.error : theme.color.tint.tertiary;
    const selectedColor = error ? theme.color.tint.error : theme.color.solid.selection;

    return css`
      .radio-handle {
        border-radius: ${({ theme }) => theme.radius.extraSmall}px;
        border: 2px solid ${borderColor};
        background-color: ${backgroundColor};
      }

      input:checked + .radio-handle {
        border-color: ${selectedColor};
        background-color: ${selectedColor};
      }

      input:focus + .radio-control:before {
        border-color: ${selectedColor};
        background-color: ${selectedColor};
        background-color: ${({ theme }) => theme.color.state.ripple};
      }

      &:hover {
        .radio-handle {
          border-color: ${theme.createOverlayColor(borderColor, 'hover')};
          background-color: ${theme.createOverlayColor(backgroundColor, 'hover')};
        }

        input:checked + .radio-handle {
          border-color: ${theme.createOverlayColor(selectedColor, 'hover')};
          background-color: ${theme.createOverlayColor(selectedColor, 'hover')};
        }
      }
    `;
  }};

  .ui-radio-text-wrapper {
    flex: 1;
    margin-left: 16px;
    color: ${({ theme }) => theme.color.tint.action};
    ${({ theme }) => theme.mappedTypography.overline.default};
  }
`;

export const RadioGroupSC = styled.div<{ layout?: TGroupLayout }>`
  display: inline-flex;
  flex-wrap: wrap;
  flex-direction: ${({ layout }) => (layout === 'horizontal' ? 'row' : 'column')};
`;
